import { setShowSubcontractorModal } from '../State/showSubcontractorModal';

export default () => async (dispatch) => {

  dispatch(setShowSubcontractorModal(false))
  
}